import { ICON__brush_clean } from '@/assets/icons_lucide';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar_8_5 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_8_5';
import { REMOTE__generation_fields_store_clean } from '@/state/generation/entity/REMOTE__generation_fields_store_clean';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useState } from 'react';

interface PROPS {}

export function G_BUTTON__fields_store_clean({}: PROPS) {
  const dispatch = use_dispatch();

  /*
   * STORE
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const [is_loading, set_is_loading] = useState(false);

  /*
   * STATE
   */

  /*
   * EVENTS
   */
  async function onClick() {
    set_is_loading(true);

    await dispatch(REMOTE__generation_fields_store_clean(generation_current._id));

    set_is_loading(false);
  }

  function is_disabled() {
    return g_general__ui_disabled || is_loading || generation_current.fields_store.is_empty();
  }

  /*
   * HTML
   */
  if (generation_current.is_stub()) return <PLACEHOLDER_BUTTON__bar_8_5 />;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return <PLACEHOLDER_BUTTON__bar_8_5 />;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      title={'Clean Fields Store'}
      variant={'no-border-on-bar'}
      Icon={ICON__brush_clean}
      disabled={is_disabled()}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      {...{ onClick }}
      className={`w-8 h-5 flex-center ${is_disabled() ? '' : 'opacity-50'}`}
      iconClassNameBase="size-3 text-gray-400"
      iconClassNameHovered="!text-bar-foreground"
    />
  );
}
